import { defineComponent as _e, ref as y, computed as g, toRef as Le, watch as ie, nextTick as K, onBeforeUnmount as Ke, h as c, Transition as We } from "vue";
import { useRefs as ae, isTouchEvent as re } from "./ghl-ui.es1062.js";
import Xe from "./ghl-ui.es1063.js";
import Ye from "./ghl-ui.es826.js";
import de from "./ghl-ui.es827.js";
import qe from "./ghl-ui.es861.js";
import Ge from "./ghl-ui.es696.js";
import { useThemeClass as se } from "./ghl-ui.es829.js";
import Je from "./ghl-ui.es697.js";
import { resolveSlot as Qe } from "./ghl-ui.es832.js";
import Ze from "./ghl-ui.es1064.js";
import { call as H } from "./ghl-ui.es866.js";
import { on as A, off as E } from "./ghl-ui.es694.js";
import { useAdjustedTo as W } from "./ghl-ui.es883.js";
import et from "./ghl-ui.es884.js";
import tt from "./ghl-ui.es885.js";
import nt from "./ghl-ui.es886.js";
const ot = 0, lt = Object.assign(Object.assign({}, de.props), {
  to: W.propTo,
  defaultValue: {
    type: [Number, Array],
    default: 0
  },
  marks: Object,
  disabled: {
    type: Boolean,
    default: void 0
  },
  formatTooltip: Function,
  keyboard: {
    type: Boolean,
    default: !0
  },
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  step: {
    type: [Number, String],
    default: 1
  },
  range: Boolean,
  value: [Number, Array],
  placement: String,
  showTooltip: {
    type: Boolean,
    default: void 0
  },
  tooltip: {
    type: Boolean,
    default: !0
  },
  vertical: Boolean,
  reverse: Boolean,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onDragstart: [Function],
  onDragend: [Function]
}), pt = _e({
  name: "Slider",
  props: lt,
  setup(o) {
    const {
      mergedClsPrefixRef: a,
      namespaceRef: N,
      inlineThemeDisabled: R
    } = Ye(o), f = de("Slider", "-slider", Xe, Ze, o, a), s = y(null), [V, D] = ae(), [ue, ce] = ae(), fe = y(/* @__PURE__ */ new Set()), X = qe(o), {
      mergedDisabledRef: x
    } = X, Y = g(() => {
      const {
        step: e
      } = o;
      if (Number(e) <= 0 || e === "mark")
        return 0;
      const t = e.toString();
      let n = 0;
      return t.includes(".") && (n = t.length - t.indexOf(".") - 1), n;
    }), P = y(o.defaultValue), he = Le(o, "value"), z = Ge(he, P), h = g(() => {
      const {
        value: e
      } = z;
      return (o.range ? e : [e]).map(te);
    }), q = g(() => h.value.length > 2), me = g(() => o.placement === void 0 ? o.vertical ? "right" : "top" : o.placement), G = g(() => {
      const {
        marks: e
      } = o;
      return e ? Object.keys(e).map(parseFloat) : null;
    }), m = y(-1), J = y(-1), w = y(-1), S = y(!1), C = y(!1), j = g(() => {
      const {
        vertical: e,
        reverse: t
      } = o;
      return e ? t ? "top" : "bottom" : t ? "right" : "left";
    }), ve = g(() => {
      if (q.value)
        return;
      const e = h.value, t = k(o.range ? Math.min(...e) : o.min), n = k(o.range ? Math.max(...e) : e[0]), {
        value: l
      } = j;
      return o.vertical ? {
        [l]: `${t}%`,
        height: `${n - t}%`
      } : {
        [l]: `${t}%`,
        width: `${n - t}%`
      };
    }), ge = g(() => {
      const e = [], {
        marks: t
      } = o;
      if (t) {
        const n = h.value.slice();
        n.sort((d, u) => d - u);
        const {
          value: l
        } = j, {
          value: i
        } = q, {
          range: r
        } = o, v = i ? () => !1 : (d) => r ? d >= n[0] && d <= n[n.length - 1] : d <= n[0];
        for (const d of Object.keys(t)) {
          const u = Number(d);
          e.push({
            active: v(u),
            label: t[d],
            style: {
              [l]: `${k(u)}%`
            }
          });
        }
      }
      return e;
    });
    function be(e, t) {
      const n = k(e), {
        value: l
      } = j;
      return {
        [l]: `${n}%`,
        zIndex: t === m.value ? 1 : 0
      };
    }
    function Q(e) {
      return o.showTooltip || w.value === e || m.value === e && S.value;
    }
    function ye(e) {
      return S.value ? !(m.value === e && J.value === e) : !0;
    }
    function Re(e) {
      var t;
      ~e && (m.value = e, (t = V.get(e)) === null || t === void 0 || t.focus());
    }
    function we() {
      ue.forEach((e, t) => {
        Q(t) && e.syncPosition();
      });
    }
    function Z(e) {
      const {
        "onUpdate:value": t,
        onUpdateValue: n
      } = o, {
        nTriggerFormInput: l,
        nTriggerFormChange: i
      } = X;
      n && H(n, e), t && H(t, e), P.value = e, l(), i();
    }
    function ee(e) {
      const {
        range: t
      } = o;
      if (t) {
        if (Array.isArray(e)) {
          const {
            value: n
          } = h;
          e.join() !== n.join() && Z(e);
        }
      } else
        Array.isArray(e) || h.value[0] !== e && Z(e);
    }
    function U(e, t) {
      if (o.range) {
        const n = h.value.slice();
        n.splice(t, 1, e), ee(n);
      } else
        ee(e);
    }
    function O(e, t, n) {
      const l = n !== void 0;
      n || (n = e - t > 0 ? 1 : -1);
      const i = G.value || [], {
        step: r
      } = o;
      if (r === "mark") {
        const u = M(e, i.concat(t), l ? n : void 0);
        return u ? u.value : t;
      }
      if (r <= 0)
        return t;
      const {
        value: v
      } = Y;
      let d;
      if (l) {
        const u = Number((t / r).toFixed(v)), b = Math.floor(u), _ = u > b ? b : b - 1, L = u < b ? b : b + 1;
        d = M(t, [Number((_ * r).toFixed(v)), Number((L * r).toFixed(v)), ...i], n);
      } else {
        const u = pe(e);
        d = M(e, [...i, u]);
      }
      return d ? te(d.value) : t;
    }
    function te(e) {
      return Math.min(o.max, Math.max(o.min, e));
    }
    function k(e) {
      const {
        max: t,
        min: n
      } = o;
      return (e - n) / (t - n) * 100;
    }
    function Se(e) {
      const {
        max: t,
        min: n
      } = o;
      return n + (t - n) * e;
    }
    function pe(e) {
      const {
        step: t,
        min: n
      } = o;
      if (Number(t) <= 0 || t === "mark")
        return e;
      const l = Math.round((e - n) / t) * t + n;
      return Number(l.toFixed(Y.value));
    }
    function M(e, t = G.value, n) {
      if (!(t != null && t.length))
        return null;
      let l = null, i = -1;
      for (; ++i < t.length; ) {
        const r = t[i] - e, v = Math.abs(r);
        // find marks in the same direction
        (n === void 0 || r * n > 0) && (l === null || v < l.distance) && (l = {
          index: i,
          distance: v,
          value: t[i]
        });
      }
      return l;
    }
    function ne(e) {
      const t = s.value;
      if (!t)
        return;
      const n = re(e) ? e.touches[0] : e, l = t.getBoundingClientRect();
      let i;
      return o.vertical ? i = (l.bottom - n.clientY) / l.height : i = (n.clientX - l.left) / l.width, o.reverse && (i = 1 - i), Se(i);
    }
    function Te(e) {
      if (x.value || !o.keyboard)
        return;
      const {
        vertical: t,
        reverse: n
      } = o;
      switch (e.key) {
        case "ArrowUp":
          e.preventDefault(), $(t && n ? -1 : 1);
          break;
        case "ArrowRight":
          e.preventDefault(), $(!t && n ? -1 : 1);
          break;
        case "ArrowDown":
          e.preventDefault(), $(t && n ? 1 : -1);
          break;
        case "ArrowLeft":
          e.preventDefault(), $(!t && n ? 1 : -1);
          break;
      }
    }
    function $(e) {
      const t = m.value;
      if (t === -1)
        return;
      const {
        step: n
      } = o, l = h.value[t], i = Number(n) <= 0 || n === "mark" ? l : l + n * e;
      U(
        // Avoid the number of value does not change when `step` is null
        O(i, l, e > 0 ? 1 : -1),
        t
      );
    }
    function De(e) {
      var t, n;
      if (x.value || !re(e) && e.button !== ot)
        return;
      const l = ne(e);
      if (l === void 0)
        return;
      const i = h.value.slice(), r = o.range ? (n = (t = M(l, i)) === null || t === void 0 ? void 0 : t.index) !== null && n !== void 0 ? n : -1 : 0;
      r !== -1 && (e.preventDefault(), Re(r), Ve(), U(O(l, h.value[r]), r));
    }
    function Ve() {
      S.value || (S.value = !0, o.onDragstart && H(o.onDragstart), A("touchend", document, F), A("mouseup", document, F), A("touchmove", document, B), A("mousemove", document, B));
    }
    function I() {
      S.value && (S.value = !1, o.onDragend && H(o.onDragend), E("touchend", document, F), E("mouseup", document, F), E("touchmove", document, B), E("mousemove", document, B));
    }
    function B(e) {
      const {
        value: t
      } = m;
      if (!S.value || t === -1) {
        I();
        return;
      }
      const n = ne(e);
      n !== void 0 && U(O(n, h.value[t]), t);
    }
    function F() {
      I();
    }
    function xe(e) {
      m.value = e, x.value || (w.value = e);
    }
    function Ce(e) {
      m.value === e && (m.value = -1, I()), w.value === e && (w.value = -1);
    }
    function ke(e) {
      w.value = e;
    }
    function Me(e) {
      w.value === e && (w.value = -1);
    }
    ie(m, (e, t) => void K(() => J.value = t)), ie(z, () => {
      if (o.marks) {
        if (C.value)
          return;
        C.value = !0, K(() => {
          C.value = !1;
        });
      }
      K(we);
    }), Ke(() => {
      I();
    });
    const oe = g(() => {
      const {
        self: {
          markFontSize: e,
          railColor: t,
          railColorHover: n,
          fillColor: l,
          fillColorHover: i,
          handleColor: r,
          opacityDisabled: v,
          dotColor: d,
          dotColorModal: u,
          handleBoxShadow: b,
          handleBoxShadowHover: _,
          handleBoxShadowActive: L,
          handleBoxShadowFocus: $e,
          dotBorder: Ie,
          dotBoxShadow: Be,
          railHeight: Fe,
          railWidthVertical: He,
          handleSize: Ae,
          dotHeight: Ee,
          dotWidth: Ne,
          dotBorderRadius: Pe,
          fontSize: ze,
          dotBorderActive: je,
          dotColorPopover: Ue
        },
        common: {
          cubicBezierEaseInOut: Oe
        }
      } = f.value;
      return {
        "--n-bezier": Oe,
        "--n-dot-border": Ie,
        "--n-dot-border-active": je,
        "--n-dot-border-radius": Pe,
        "--n-dot-box-shadow": Be,
        "--n-dot-color": d,
        "--n-dot-color-modal": u,
        "--n-dot-color-popover": Ue,
        "--n-dot-height": Ee,
        "--n-dot-width": Ne,
        "--n-fill-color": l,
        "--n-fill-color-hover": i,
        "--n-font-size": ze,
        "--n-handle-box-shadow": b,
        "--n-handle-box-shadow-active": L,
        "--n-handle-box-shadow-focus": $e,
        "--n-handle-box-shadow-hover": _,
        "--n-handle-color": r,
        "--n-handle-size": Ae,
        "--n-opacity-disabled": v,
        "--n-rail-color": t,
        "--n-rail-color-hover": n,
        "--n-rail-height": Fe,
        "--n-rail-width-vertical": He,
        "--n-mark-font-size": e
      };
    }), p = R ? se("slider", void 0, oe, o) : void 0, le = g(() => {
      const {
        self: {
          fontSize: e,
          indicatorColor: t,
          indicatorBoxShadow: n,
          indicatorTextColor: l,
          indicatorBorderRadius: i
        }
      } = f.value;
      return {
        "--n-font-size": e,
        "--n-indicator-border-radius": i,
        "--n-indicator-box-shadow": n,
        "--n-indicator-color": t,
        "--n-indicator-text-color": l
      };
    }), T = R ? se("slider-indicator", void 0, le, o) : void 0;
    return {
      mergedClsPrefix: a,
      namespace: N,
      uncontrolledValue: P,
      mergedValue: z,
      mergedDisabled: x,
      mergedPlacement: me,
      isMounted: Je(),
      adjustedTo: W(o),
      dotTransitionDisabled: C,
      markInfos: ge,
      isShowTooltip: Q,
      shouldKeepTooltipTransition: ye,
      handleRailRef: s,
      setHandleRefs: D,
      setFollowerRefs: ce,
      fillStyle: ve,
      getHandleStyle: be,
      activeIndex: m,
      arrifiedValues: h,
      followerEnabledIndexSet: fe,
      handleRailMouseDown: De,
      handleHandleFocus: xe,
      handleHandleBlur: Ce,
      handleHandleMouseEnter: ke,
      handleHandleMouseLeave: Me,
      handleRailKeyDown: Te,
      indicatorCssVars: R ? void 0 : le,
      indicatorThemeClass: T == null ? void 0 : T.themeClass,
      indicatorOnRender: T == null ? void 0 : T.onRender,
      cssVars: R ? void 0 : oe,
      themeClass: p == null ? void 0 : p.themeClass,
      onRender: p == null ? void 0 : p.onRender
    };
  },
  render() {
    var o;
    const {
      mergedClsPrefix: a,
      themeClass: N,
      formatTooltip: R
    } = this;
    return (o = this.onRender) === null || o === void 0 || o.call(this), c("div", {
      class: [`${a}-slider`, N, {
        [`${a}-slider--disabled`]: this.mergedDisabled,
        [`${a}-slider--active`]: this.activeIndex !== -1,
        [`${a}-slider--with-mark`]: this.marks,
        [`${a}-slider--vertical`]: this.vertical,
        [`${a}-slider--reverse`]: this.reverse
      }],
      style: this.cssVars,
      onKeydown: this.handleRailKeyDown,
      onMousedown: this.handleRailMouseDown,
      onTouchstart: this.handleRailMouseDown
    }, c("div", {
      class: `${a}-slider-rail`
    }, c("div", {
      class: `${a}-slider-rail__fill`,
      style: this.fillStyle
    }), this.marks ? c("div", {
      class: [`${a}-slider-dots`, this.dotTransitionDisabled && `${a}-slider-dots--transition-disabled`]
    }, this.markInfos.map((f) => c("div", {
      key: f.label,
      class: [`${a}-slider-dot`, {
        [`${a}-slider-dot--active`]: f.active
      }],
      style: f.style
    }))) : null, c("div", {
      ref: "handleRailRef",
      class: `${a}-slider-handles`
    }, this.arrifiedValues.map((f, s) => {
      const V = this.isShowTooltip(s);
      return c(et, null, {
        default: () => [c(tt, null, {
          default: () => c("div", {
            ref: this.setHandleRefs(s),
            class: `${a}-slider-handle-wrapper`,
            tabindex: this.mergedDisabled ? -1 : 0,
            style: this.getHandleStyle(f, s),
            onFocus: () => {
              this.handleHandleFocus(s);
            },
            onBlur: () => {
              this.handleHandleBlur(s);
            },
            onMouseenter: () => {
              this.handleHandleMouseEnter(s);
            },
            onMouseleave: () => {
              this.handleHandleMouseLeave(s);
            }
          }, Qe(this.$slots.thumb, () => [c("div", {
            class: `${a}-slider-handle`
          })]))
        }), this.tooltip && c(nt, {
          ref: this.setFollowerRefs(s),
          show: V,
          to: this.adjustedTo,
          enabled: this.showTooltip && !this.range || this.followerEnabledIndexSet.has(s),
          teleportDisabled: this.adjustedTo === W.tdkey,
          placement: this.mergedPlacement,
          containerClass: this.namespace
        }, {
          default: () => c(We, {
            name: "fade-in-scale-up-transition",
            appear: this.isMounted,
            css: this.shouldKeepTooltipTransition(s),
            onEnter: () => {
              this.followerEnabledIndexSet.add(s);
            },
            onAfterLeave: () => {
              this.followerEnabledIndexSet.delete(s);
            }
          }, {
            default: () => {
              var D;
              return V ? ((D = this.indicatorOnRender) === null || D === void 0 || D.call(this), c("div", {
                class: [`${a}-slider-handle-indicator`, this.indicatorThemeClass, `${a}-slider-handle-indicator--${this.mergedPlacement}`],
                style: this.indicatorCssVars
              }, typeof R == "function" ? R(f) : f)) : null;
            }
          })
        })]
      });
    })), this.marks ? c("div", {
      class: `${a}-slider-marks`
    }, this.markInfos.map((f) => c("div", {
      key: f.label,
      class: `${a}-slider-mark`,
      style: f.style
    }, f.label))) : null));
  }
});
export {
  pt as default,
  lt as sliderProps
};
